/*
 *  (c) 2015 - 2022 ENISCO by FORCAM GmbH
 */

import {useSelector} from 'react-redux'
import {AppRootState} from '../model/config'

const useDefaultParameters = () => {
  const defaultParameters = useSelector(
    (state: AppRootState) => state.app.defaultParameters
  )

  return [defaultParameters]
}

export default useDefaultParameters
